import {AgendaToolbarTitle} from '@/features/agenda/components/agenda-toolbar-title/AgendaToolbarTitle'
import {AgendaToolbarHandler} from './AgendaToolbarHandler'
import {AgendaToolbarOptions} from './AgendaToolbarOptions'
import {StyledAgendaToolbar} from './style'

export const AgendaCalendarToolbar = () => {
    return (
        <StyledAgendaToolbar>
            <AgendaToolbarHandler />
            <AgendaToolbarTitle />
            <AgendaToolbarOptions />
        </StyledAgendaToolbar>
    )
}
